import React from "react";
import styled, { css } from "styled-components";
import { motion } from "framer-motion";

// Стиль для секции
const Section = styled(motion.section)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: #f4f4f4;
  color: #333;
  transition: background 0.5s ease;
  h1, p, button {
    z-index: 1;
    position: relative;
    text-align: center;
  }
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

// Заголовок
const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 2rem;
  color: #007aff;
  @media (max-width: 768px) {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
  }
`;

// Контейнер для карточек товаров
const ProductsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
  padding: 2rem;
  @media (max-width: 768px) {
    gap: 1rem;
    padding: 1rem;
  }
`;

// Стили для карточек товаров
const ProductCard = styled(motion.div)`
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 300px;
  margin: 1rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  }
  @media (max-width: 768px) {
    width: 100%;
    max-width: 300px;
  }
`;

// Изображение товара
const ProductImage = styled(motion.img)`
  width: 100%;
  height: 200px;
  object-fit: contain; /* Изменено с cover на contain */
  border-radius: 8px;
  transition: transform 0.3s ease;
  &:hover {
    transform: scale(1.05);
  }
  @media (max-width: 768px) {
    height: 150px;
  }
`;

// Название товара
const ProductName = styled.h2`
  font-size: 1.5rem;
  margin: 1rem 0;
  color: #333;
  @media (max-width: 768px) {
    font-size: 1.2rem;
    margin: 0.5rem 0;
  }
`;

// Описание товара
const ProductDescription = styled.p`
  font-size: 1rem;
  color: #555;
  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

// Цена товара
const ProductPrice = styled.p`
  font-size: 1.2rem;
  color: #007aff;
  font-weight: bold;
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const Equipment = () => {
  const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  const products = [
    {
      id: 1,
      name: "УКП-7",
      description: "Устройство переговорное Vizit УКП-7 — компактное и качественное решение для переговоров. Четкий микрофон и динамик обеспечивают отличное звучание. Тип сопряжения: координатный. Цвет: светло-кремовый",
      price: "1250 ₽",
      image: "/Photoequipment/YKP7.webp",
    },
    {
      id: 2,
      name: "УКП-7М",
      description: "Устройство переговорное Vizit УКП-7М — компактное и качественное решение для переговоров. Четкий микрофон и динамик обеспечивают отличное звучание. Тип сопряжения: координатный. Цвет: серебристый",
      price: "1350 ₽",
      image: "/Photoequipment/YKP7M.webp",
    },
    {
      id: 3,
      name: "УКП-12",
      description: "Устройство переговорное Vizit УКП-12 — компактное и надежное решение для переговоров. Четкий микрофон и динамик обеспечивают отличное звучание. Тип сопряжения: координатный. Цвет: белый.",
      price: "1650 ₽",
      image: "/Photoequipment/YKP12.webp",
    },
    {
      id: 4,
      name: "УКП-12М",
      description: "Устройство переговорное Vizit УКП-12М — компактное и надежное решение для переговоров. Четкий микрофон и динамик обеспечивают отличное звучание. Тип сопряжения: координатный. Цвет: серебристый.",
      price: "1650 ₽",
      image: "/Photoequipment/YKP12M.webp",
    },
    {
      id: 5,
      name: "УКП-12G",
      description: "Устройство переговорное Vizit УКП-12G — компактное и надежное решение для переговоров. Четкий микрофон и динамик обеспечивают отличное звучание. Тип сопряжения: координатный. Цвет: графит.",
      price: "2000 ₽",
      image: "/Photoequipment/УКП-12G.jpg",
    },
    {
      id: 6,
      name: "УКП-12GR",
      description: "Устройство переговорное Vizit УКП-12GR — компактное и надежное решение для переговоров. Четкий микрофон и динамик обеспечивают отличное звучание. Тип сопряжения: координатный. Цвет: мокрый асфальт.",
      price: "2000 ₽",
      image: "/Photoequipment/УКП-12GR.jpg",
    },
    {
      id: 7,
      name: "УКП-12NA",
      description: "Устройство переговорное Vizit УКП-12NA — компактное и надежное решение для переговоров. Четкий микрофон и динамик обеспечивают отличное звучание. Тип сопряжения: координатный. Цвет: глубокий синий.",
      price: "2000 ₽",
      image: "/Photoequipment/12na.jpg",
    },
    {
      id: 8,
      name: "УКП-12MS",
      description: "Устройство переговорное Vizit УКП-12MS — компактное и надежное решение для переговоров. Четкий микрофон и динамик обеспечивают отличное звучание. Тип сопряжения: координатный. Цвет: небесно голубой.",
      price: "2000 ₽",
      image: "/Photoequipment/12ms.jpg",
    },
    {
      id: 9,
      name: "УКП-12CH",
      description: "Устройство переговорное Vizit УКП-12CH — компактное и надежное решение для переговоров. Четкий микрофон и динамик обеспечивают отличное звучание. Тип сопряжения: координатный. Цвет: серый.",
      price: "2000 ₽",
      image: "/Photoequipment/12ch.jpg",
    },
    {
      id: 10,
      name: "LM-8D",
      description: "Устройство переговорное Vizit LM-8D — компактное и надежное решение для переговоров. Четкий микрофон и динамик обеспечивают отличное звучание. Тип сопряжения: цифровой. Цвет: белый.",
      price: "2000 ₽",
      image: "/Photoequipment/LM-8D.png",
    },
  ];

  return (
    <main>
      {/* Секция 1: Заголовок */}
      <Section
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        bgColor="#f4f4f4"
        textColor="#333"
        style={{ marginTop: '60px' }} // Добавляем отступ сверху
      >
        <header>
          <Title>Оборудование</Title>
        </header>
      </Section>

      {/* Секция 2: Товары */}
      <section aria-labelledby="products-heading">
        <ProductsContainer>
          {products.map((product) => (
            <article key={product.id} role="article" aria-labelledby={`product-${product.id}`}>
              <ProductCard
                whileHover={{ scale: 1.03 }}
                transition={{ duration: 0.3, type: "spring", stiffness: 300 }}
              >
                <ProductImage
                  src={product.image}
                  alt={product.name}
                  loading="lazy" // Ленивая загрузка изображений
                />
                <ProductName id={`product-${product.id}`}>{product.name}</ProductName>
                <ProductDescription>{product.description}</ProductDescription>
                <ProductPrice>{product.price}</ProductPrice>
              </ProductCard>
            </article>
          ))}
        </ProductsContainer>
      </section>
    </main>
  );
};

export default Equipment;